import { render } from "./MySelectSo.vue?vue&type=template&id=67ba16c2&scoped=true"
import script from "./MySelectSo.vue?vue&type=script&lang=js"
export * from "./MySelectSo.vue?vue&type=script&lang=js"

import "./MySelectSo.vue?vue&type=style&index=0&id=67ba16c2&lang=css"
import "./MySelectSo.vue?vue&type=style&index=1&id=67ba16c2&scoped=scoped&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ba16c2"]])

export default __exports__